import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb9ca458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper left-menu" }
const _hoisted_2 = {
  key: 0,
  class: "mask-ui mask-ui-overlay mask-ui-overlay-enter"
}
const _hoisted_3 = { class: "top-bar flex sticky align-items-center z-1" }
const _hoisted_4 = { class: "font-medium text-gray-l1 ml-3" }
const _hoisted_5 = { class: "layout-content-wrapper" }
const _hoisted_6 = { class: "menu-wrapper right-menu" }
const _hoisted_7 = { class: "layout-menu-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_RightAppMenu = _resolveComponent("RightAppMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.layoutContainerClass)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "layout-menu-container",
        onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuItemMouseEnter && _ctx.onMenuItemMouseEnter(...args))),
        onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMenuItemMouseLeave && _ctx.onMenuItemMouseLeave(...args)))
      }, [
        _createVNode(_component_AppMenu, {
          onMenubuttonClick: _ctx.onMenuButtonClick,
          hoverMenuActive: _ctx.hoverMenuActive,
          menuActive: _ctx.leftMenuActive
        }, null, 8, ["onMenubuttonClick", "hoverMenuActive", "menuActive"])
      ], 32)
    ]),
    _createElementVNode("div", {
      class: "layout-main",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideMenus()))
    }, [
      (_ctx.leftMenuActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view),
        _createVNode(_component_AppFooter)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_RightAppMenu, {
          onRightMenubuttonClick: _ctx.onRightMenuButtonClick,
          menuActive: _ctx.rightMenuActive
        }, null, 8, ["onRightMenubuttonClick", "menuActive"])
      ])
    ])
  ], 2))
}